export const YesNoChar = {
  YES: 'Y',
  NO: 'N',
};

export const SelectOptions = {
  InsurerNotListed: 'Insurer Not Listed Below',
};
